export default __webpack_public_path__ + "static/buynowtag-c6904bfccaa7768337f0d9ea1efc758b.png";